export default __webpack_public_path__ + "static-front/media/arrowSidebar.80b03b76.svg";